import { UserExtraDetailsWebComponent } from './component/UserExtraDetailsWebComponent';

export { UserExtraDetailsWebComponent };
